export function resolveGraphqlEndpoint(): string {
  const configured = process.env.REACT_APP_GRAPHQL_URL?.trim();
  if (configured) {
    if (/^https?:\/\//i.test(configured)) return configured;
    const base =
      typeof window !== "undefined"
        ? window.location.origin
        : "http://localhost:3000";
    return new URL(configured, base).toString();
  }

  if (typeof window !== "undefined") {
    return new URL("/api/graphql", window.location.origin).toString();
  }

  return "http://localhost:3000/api/graphql";
}

export function resolveAdminGraphqlEndpoint(): string {
  const configured = process.env.REACT_APP_ADMIN_GRAPHQL_URL?.trim();
  if (configured) {
    if (/^https?:\/\//i.test(configured)) return configured;
    const base =
      typeof window !== "undefined"
        ? window.location.origin
        : "http://localhost:3000";
    return new URL(configured, base).toString();
  }

  if (typeof window !== "undefined") {
    return new URL("/admin/api/graphql", window.location.origin).toString();
  }

  return "http://localhost:3000/admin/api/graphql";
}
